export const ESS_LOGO =
  "https://customer-assets.emergentagent.com/job_dff8c892-eb3a-4529-9061-e90399a5133e/artifacts/3upqc6ja_Elegant_Exit_Strategy_Logo.png";

export const ESS_LOGO_DARK =
  "https://customer-assets.emergentagent.com/job_emerald-leadership/artifacts/50il1ur0_Elegant%20Metallic%20Logo%20Design.png";

export const ESS_LOGO_ALT =
  "https://customer-assets.emergentagent.com/job_dff8c892-eb3a-4529-9061-e90399a5133e/artifacts/8z1wy8vw_ChatGPT_Image_Dec_5_2025_09_43_10_PM.png";

export const FOUNDER_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_emerald-leadership/artifacts/h0ate785_ChatGPT%20Image%20Jun%2014%2C%202026%2C%2012_09_05%20AM.png";

export const FOUNDER_PORTRAIT_ALT =
  "https://customer-assets.emergentagent.com/job_emerald-leadership/artifacts/p799p0la_ChatGPT%20Image%20Jun%2014%2C%202026%2C%2012_09_15%20AM.png";

export const FOUNDER_COLLAGE =
  "https://customer-assets.emergentagent.com/job_emerald-leadership/artifacts/56noewbd_ChatGPT%20Image%20Jun%2014%2C%202026%2C%2012_09_19%20AM.png";

export const FOUNDER_BANNER =
  "https://customer-assets.emergentagent.com/job_dff8c892-eb3a-4529-9061-e90399a5133e/artifacts/69vmzhx8_61222414-DA69-4833-94E5-FD20684EF51B.png";

export const LIFESTYLE = {
  executiveWoman:
    "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=1600",
  meeting:
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=1600",
  office:
    "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1600",
  digitalEducation:
    "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=1600",
  womenLeading:
    "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=crop&q=80&w=1600",
  workspace:
    "https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&q=80&w=1600",
  speaker:
    "https://images.unsplash.com/photo-1559223607-a43c990c692c?auto=format&fit=crop&q=80&w=1600",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/digital-products", label: "Digital Products", testid: "nav-products" },
  { to: "/resources", label: "Resources", testid: "nav-resources" },
  { to: "/impact", label: "Impact", testid: "nav-impact" },
  { to: "/partnerships", label: "Partnerships", testid: "nav-partnerships" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/profile.php?id=61584836827452",
  instagram: "https://www.instagram.com/exitstrategysociety",
  tiktok: "https://www.tiktok.com/@exitstrategysocietyceo?lang=en",
  linkedin: "https://www.linkedin.com/in/phelesia-foster-ph-d-chc-broker-98016a3a",
  youtube: "https://www.youtube.com/@ESSbyDrPhe",
};

export const CALENDLY_URL = "https://calendly.com/exitstrategysociety/30min";

export const ETSY_URL = "https://www.etsy.com/shop/ExitStrategyBoutique";

export const FOOTER_DISCLAIMER =
  "Content provided by The Exit Strategy Society is for educational and informational purposes only and should not be construed as legal, tax, financial, investment, medical, or professional advice. Individual results may vary.";
